import { Link } from 'react-router-dom';
import type { VideoItem } from '@/mocks/videos';

interface VideoCardProps {
  video: VideoItem;
}

export default function VideoCard({ video }: VideoCardProps) {
  return (
    <Link
      to={`/article/${video.id}`}
      className="group block rounded-lg overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-300 transition-all duration-300 cursor-pointer"
    >
      <div className="relative aspect-[3/4] overflow-hidden">
        <img
          src={video.coverImage}
          alt={video.title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent"></div>

        {video.isHot && (
          <span className="absolute top-2 left-2 px-2 py-0.5 rounded-md bg-accent-500 text-background-50 text-xs font-medium whitespace-nowrap">
            热门
          </span>
        )}
        {video.isNew && (
          <span className="absolute top-2 left-2 px-2 py-0.5 rounded-md bg-primary-500 text-background-50 text-xs font-medium whitespace-nowrap">
            最新
          </span>
        )}
        {video.isHot && video.isNew && (
          <>
            <span className="absolute top-2 left-2 px-2 py-0.5 rounded-md bg-accent-500 text-background-50 text-xs font-medium whitespace-nowrap">
              热门
            </span>
            <span className="absolute top-2 left-[58px] px-2 py-0.5 rounded-md bg-primary-500 text-background-50 text-xs font-medium whitespace-nowrap">
              最新
            </span>
          </>
        )}

        <div className="absolute bottom-2 right-2 px-2 py-0.5 rounded-md bg-black/60 text-background-50 text-xs whitespace-nowrap">
          <i className="ri-play-fill mr-0.5"></i>
          {video.episodes}
        </div>

        <div className="absolute bottom-2 left-2 flex items-center gap-1 text-background-50 text-xs">
          <i className="ri-star-fill text-accent-500 text-xs"></i>
          <span>{video.rating}</span>
        </div>
      </div>

      <div className="p-3">
        <h3 className="text-sm font-semibold text-foreground-900 line-clamp-2 leading-snug group-hover:text-primary-600 transition-colors duration-200">
          {video.title}
        </h3>
        <div className="flex items-center gap-2 mt-2 text-xs text-foreground-500">
          <span>{video.year}</span>
          <span>·</span>
          <span>{video.region}</span>
        </div>
        {video.tags.length > 0 && (
          <div className="flex items-center gap-1.5 mt-2 flex-wrap">
            {video.tags.slice(0, 2).map((tag) => (
              <span key={tag} className="px-2 py-0.5 rounded-md bg-secondary-100 text-secondary-700 text-xs whitespace-nowrap">
                {tag}
              </span>
            ))}
          </div>
        )}
      </div>
    </Link>
  );
}